<ng-container *ngIf="!isMobile; else elseBlock">
    <button
        id="favButton"
        class="header-icon "
        mat-mini-fab
        #menuTrigger="matMenuTrigger"
        matBadgePosition="after"
        (click)="checkUserGuest()"
        (mouseenter)="toggleMenu($event, true)"
        (mouseleave)="toggleMenu($event, false)"
        [matMenuTriggerFor]="viewwishlist"
        id="wishlist"
        [ngClass]="{
          'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  'icons-background' :
          ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
      }"
    >
        <mat-icon 
        (mouseover)="changeIconFill=false"
        (mouseleave)="changeIconFill=true"
        id="favIcon" class="material-icons notranslate  defulat-icons-color " 
        [ngClass]="{
          'material-symbols-outlined':(changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
          'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
      }">
            favorite
        </mat-icon>
        <span class="header-icon__badge" *ngIf="wishListProducts?.length"
        [ngClass]="{
          'icons-background icons-fill-color' :   ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) ,
          'defult-background-icons' : ( !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND )
      }"
        >{{
            wishListProducts?.length
        }}</span>
    </button>
    <mat-menu #viewwishlist="matMenu" [hasBackdrop]="false">
        <ng-container *ngIf="wishListProducts?.length; else elseBlock">
            <div
                class="drop-wrap"
                (mouseenter)="enteredMenu = true"
                (mouseleave)="closeMatMenu()"
            >
                <div
                    class="cart-menu-list p-2 min-h-100"
                    fxLayoutAlign="start center"
                    *ngFor="let product of wishListProducts; let idx = index"
                >
                <!-- [queryParams]="{ variant: product?.id }" -->
                    <div>
                        <a
                            [routerLink]="[
                                '/' + lang + '/' + product.slug
                            ]"
                        >
                            <img  loading="lazy" 
                                [src]="product?.image"
                                class="no-outline img-thumb"
                                onError="this.src='./assets/images/placeholder200.jpg';"
                                default="./assets/images/placeholder200.jpg"
                                style="outline: none"
                                   [alt]="product?.name"
                            />
                        </a>
                    </div>
                    <div class="px-3">
                        <h6 class="mb-0">
                          <!-- [queryParams]="{ variant: product?.id }" -->
                            <a class='product-name'
                                [routerLink]="[
                                    '/' +
                                        lang +
                                        '/' +
                                        product.slug
                                ]"
                            >
                                {{
                                    lang == "en"
                                        ? product?.name_en
                                        : product?.name_ar
                                }}
                            </a>
                        </h6>

                        <span
                        style="font-size: 13px !important;"
                            *ngIf="product?.price && environmentVariables?.GUEST_CAN_VIEW_PRICES"
                            class="font-bold defult-price-color"
                            [ngClass]="{'config-price-after-discount' : product?.discount_price &&  environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR ,
                            'config-price-color' : environmentVariables?.PRODUCT_PRICE_TEXT_COLOR , 
                            'defult-price-color-after-discount':!environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR && product?.discount_price ,
                            'arabic-currency': lang == 'ar' 
                      }"
                        >
                            {{ product?.price | number }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </span>
                        <br />
                        <span
                            class="font-bold defult-price-color"
                            *ngIf="product?.discount_price && environmentVariables?.GUEST_CAN_VIEW_PRICES"
                            [ngClass]="{'config-price-before-discount' : product?.discount_price && environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR ,
                            'arabic-currency' : lang == 'ar' 
                          }"
                        >
                            {{ product?.discount_price | number }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </span>
                    </div>
                    <div
                        class="cart-menu-action"
                        (click)="$event.stopPropagation()"
                    >
                        <button
                            mat-mini-fab
                            mat-raised-button
                            class="bg-primary position-in-image"
                            [ngClass]="{ 'position-in-image-ar': lang == 'ar' }"
                            [disabled]="product['loading']"
                            (click)="openConfirmationPopup(product, idx)"
                        >
                            <app-loading
                                *ngIf="product['loading']"
                            ></app-loading>
                            <mat-icon class="material-icons"> close </mat-icon>
                        </button>
                    </div>

                    <div
                        class="cart-menu-action"
                        (click)="$event.stopPropagation()"
                    ></div>
                </div>
                <div class="footer-menu px-3 pb-2 pt-2">
                    <button
                        mat-raised-button
                        color="accent"
                        class="w-100 color-primary"
                        (click)="checkUserGuest()"
                    >
                        {{ "button.viewAll" | translate }}
                    </button>
                </div>
            </div>
        </ng-container>
        <ng-template #elseBlock>
            <div
                (mouseenter)="enteredMenu = true"
                (mouseleave)="closeMatMenu()"
                class="cart-menu-list p-2 empty-list"
                fxLayoutAlign="center center"
            >
                {{
                    lang == "en" ? "No Product Found." : "لا توجد منتجات حاليآ "
                }}
            </div>
        </ng-template>
    </mat-menu>
</ng-container>

<ng-template #elseBlock>
    <button
        class="header-icon "
        [ngClass]="{
          'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  'icons-background' :
          ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
      }"
        [ngStyle]="{'background-color' : environmentVariables.HEADER_ICONS_BACKGROUND_COLOR}"
        mat-mini-fab
        matBadgePosition="after"
        (click)="checkUserGuest()"
    >
        <mat-icon 
        (mouseover)="changeIconFill=false"
        (mouseleave)="changeIconFill=true"
        class="material-icons notranslate defulat-icons-color"
        [ngClass]="{
          'material-symbols-outlined': (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
          'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
      }"
        > favorite </mat-icon>
        <span class="header-icon__badge" *ngIf="wishListProducts?.length"
        [ngClass]="{
          'icons-background icons-fill-color'  :   ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR ) ,
          'defult-background-icons' : ( !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND )
      }"
        >{{
            wishListProducts?.length
        }}</span>
    </button>
</ng-template>
